<template>
    <div :class="'x12 m:x12 l:x11 xl:x10 m-x-a '+(padding?'':'m:')+'p-x-4'">
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'Container',
  props: ['padding']
}
</script>
